export default function createQuickSearchesTrackingService(
    track: (category: string, action: string, eventName: string) => void,
) {
    function trackWithPresets(action: string, eventSubSubName = "") {
        track("lead gen filter actions", action, `overlay/saved searches/${eventSubSubName}`);
    }

    return {
        trackSavedSearchClicked(name: string) {
            trackWithPresets("Select existing search", name);
        },

        trackSavedSearchDeleted(name: string) {
            trackWithPresets("Delete", name);
        },

        trackNewSearchClicked() {
            trackWithPresets("Select new search", "new search");
        },
        trackOverlayOpened() {
            trackWithPresets("Open overlay");
        },
    };
}
